// CSV の列名からジオメトリの作り方を判定する（純関数・DuckDB 非依存・テスト対象）。
//
// 役割: CSV はジオメトリを内包しないため、列名のヒューリスティクスで
//       (a) WKT 列、(b) 経度・緯度列 のどちらでジオメトリを作るかを決める。
// 関係: loadFile.js の createTableFromCsv がこの判定結果に従って geom 列を生成する。
//
// 判定方針: WKT 列を優先（より表現力が高い）。無ければ経度・緯度列。どちらも無ければ null。

const WKT_RE = /^(wkt|geometry|geom|the_geom)$/i
const LON_RE = /^(lon|lng|long|longitude|x|経度)$/i
const LAT_RE = /^(lat|latitude|y|緯度)$/i

// columnNames: 文字列配列（CSV のヘッダ列名）
// 戻り値: { mode: 'wkt' | 'lonlat' | null, wktColumn?, lonColumn?, latColumn? }
export function detectCsvGeometry(columnNames = []) {
  const cols = columnNames.filter((c) => typeof c === 'string')

  const wktColumn = cols.find((c) => WKT_RE.test(c))
  if (wktColumn) return { mode: 'wkt', wktColumn }

  const lonColumn = cols.find((c) => LON_RE.test(c))
  const latColumn = cols.find((c) => LAT_RE.test(c))
  if (lonColumn && latColumn) return { mode: 'lonlat', lonColumn, latColumn }

  return { mode: null }
}
